import { connect } from 'react-redux'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'
import {
  loadNearbyPlaces,
} from 'Modules/places/actions'

import Demographics from './Demographics'

const mapStateToProps = state => ({
  mobileBrowser: state.app.mobileBrowser,
})

const dispathes = {
  googleAnalyticsEvent,
  loadNearbyPlaces,
}

export default connect(mapStateToProps, dispathes)(Demographics)
